import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Marquee from './Marquee';

const Layout = ({ onOpenDemo }) => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden flex flex-col">
      <Header onOpenDemo={onOpenDemo} />
      <main id="main" role="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Marquee onOpenDemo={onOpenDemo} />
    </div>
  );
};

export default Layout;
